module.exports = __webpack_public_path__ + "img/1_032.22698c2b.jpg";